import { Page } from '../../types'

const suspectedWhistleBlowing: Page[] = [
    {
        pageType: 'question',
        title: 'Allegations of suspected whistle blowing',
        name: 'allegations-of-suspected-WhistleBlowing',
        questions: [
            {
                questionType: 'instanceInput',
                title: 'Total number of instances',
                name: 'whistleblowing-total-instances',
                hint: '',
                rules: {
                    required: false
                }
            },
            {
                questionType: 'costInput',
                title: 'Estimated total value',
                name: 'whistleblowing-estimated-total',
                hint: '',
                rules: {
                    required: false
                }
            },    
            {
                questionType: 'textarea',
                title: 'Comments',
                name: 'whistleblowing-text-comments',
                hint: 'Please ensure you do not include any personal or sensitive information',
                rules: {
                    required: false
                }
            }
        ]
    },
]
export default suspectedWhistleBlowing
